import { render, staticRenderFns } from "./DetailVodCard.vue?vue&type=template&id=d3019960&scoped=true&"
import script from "./DetailVodCard.vue?vue&type=script&lang=js&"
export * from "./DetailVodCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailVodCard.vue?vue&type=style&index=0&id=d3019960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3019960",
  null
  
)

export default component.exports